/** One server-sent event: the `event:` name (default `message`) and the joined `data:` lines. */
export interface SseEvent {
  event: string;
  data: string;
}

/**
 * Splits accumulated SSE text into complete events (a blank line terminates one) and returns the
 * unparsed remainder to prepend to the next chunk. Pure, so a stream split at any byte parses the
 * same. Comments (`: …`) are ignored; `id:`/`retry:` are not needed here and are ignored too.
 */
export function parseSse(buffer: string): { events: SseEvent[]; rest: string } {
  const text = buffer.replace(/\r\n/g, '\n');
  const events: SseEvent[] = [];
  let start = 0;
  for (;;) {
    const end = text.indexOf('\n\n', start);
    if (end === -1) break;
    const block = text.slice(start, end);
    start = end + 2;
    let event = 'message';
    const data: string[] = [];
    for (const line of block.split('\n')) {
      if (!line || line.startsWith(':')) continue;
      const colon = line.indexOf(':');
      const field = colon === -1 ? line : line.slice(0, colon);
      const value = colon === -1 ? '' : line.slice(colon + 1).replace(/^ /, '');
      if (field === 'event') event = value;
      else if (field === 'data') data.push(value);
    }
    if (data.length > 0) events.push({ event, data: data.join('\n') });
  }
  return { events, rest: text.slice(start) };
}
